import { Box } from "@mui/material";
import Hero from "./Hero";
import StatBlock from "./stat-block";
import Offerings from "./offerings";
import Footer from "../../components/Footer";
import Reviews from "./Reviews";
import Villas from "./Villas";
import Navbar from "../../components/Navbar";
import FAQ from "./FAQ";

const Landing = () => {
  return (
    <Box>
      <Navbar />
      <Hero />
      <StatBlock />
      <Villas />
      <Offerings />
      <Reviews />
      <FAQ />
      <Footer />
    </Box>
  );
};

export default Landing;
